/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { TagEntity } from './tag-entity';
export class LawSchoolEntity extends Entity {
  id: string = '';
  name: string | null = null;
  tags: TagEntity[] = [];
  static override key = 'LawSchool';
  static override get schema() {
    return {
      tags: [TagEntity],
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'LawSchool' in input
    ) {
      const { LawSchool: wrapped, ...rest } = input as {
        LawSchool: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}